import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./guidelinesModal.css";

import StepProgressBar from "react-step-progress";
import "react-step-progress/dist/index.css";
import stepContentPage1 from "../../step-content-page-1";
import stepContentPage2 from "../../step-content-page-2";
import stepContentPage3 from "../../step-content-page-3";


const GuidelinesModal = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  React.useState(() => {
    if (!localStorage.getItem("readGuide")) {
      setShow(true);
    }
  }, []);

  const handleHide = () => {
    localStorage.setItem("readGuide", true);
    setShow(false);
  };

  return (
    <>
      <Button variant="info" onClick={handleShow}>
        <FontAwesomeIcon icon={faQuestionCircle} className="mr-2" />
        &nbsp;
      </Button>

      <Modal
        // trying to fix issue with modal appearing behind some existing elements
        fade={false}
        style={{ overlay: { zIndex: 999 }, opacity: 1 }}
        animation={false}
        transition={false}
        // end of the fix

        show={show}
        onHide={handleClose}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>How To Use Document Parser Template Editor </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBody">
          <div>
            <StepProgressBar
              steps={[
                {
                  name: "step 1",
                  content: (
                    <div
                      dangerouslySetInnerHTML={{ __html: stepContentPage1 }}
                    />
                  ),
                },
                {
                  name: "step 2",
                  content: (
                    <div className="stepWrap"
                      dangerouslySetInnerHTML={{ __html: stepContentPage2 }}
                    />
                  ),
                },
                {
                  name: "step 3",
                  content: (
                    <div className="stepWrap"
                         dangerouslySetInnerHTML={{ __html: stepContentPage3 }}
                    />
                  ),
                },
              ]}
              startingStep={0}
              wrapperClass="wrapperWrap"
              progressClass="progressBar"
              buttonWrapperClass="buttonWrapper"
              contentClass="content"
              previousBtnName="Back"
              primaryBtnClass="primaryBtn"
              secondaryBtnClass="secondaryBtn"
              submitBtnName="Close"
              onSubmit={handleHide}
            />
            <Button
              variant="secondary"
              onClick={handleHide}
              className="skipBtn"
            >
              Skip
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GuidelinesModal;
